/*var elem = document.querySelector('.menuListProducts');
var flkty = new Flickity(elem, {
  cellAlign: 'center',
  contain: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false
});
*/
document.addEventListener("DOMContentLoaded", function () {
  const heading = document.querySelector(".pair-it-heading");
  const menuListProducts = document.querySelector(".menuListProducts");
  const drawer = document.querySelector(".drawer");

  function updateVisibility() {
      if (drawer.classList.contains("active")) {
          heading.style.opacity = "1";
          heading.style.visibility = "visible";
          menuListProducts.style.opacity = "1";
          menuListProducts.style.visibility = "visible";
      } else {
          heading.style.opacity = "0";
          heading.style.visibility = "hidden";
          menuListProducts.style.opacity = "0";
          menuListProducts.style.visibility = "hidden";
      }
  }

  // Inicializa la visibilidad al cargar la página
  updateVisibility();

  // Observa cambios en la clase .active de .drawer
  const observer = new MutationObserver(updateVisibility);
  observer.observe(drawer, { attributes: true });

  // Si necesitas detectar cambios en el click del icono del carrito
  const cartIconBubble = document.getElementById("cart-icon-bubble");
  cartIconBubble.addEventListener("click", updateVisibility);

  class CartDrawerCarousel extends HTMLElement {
    constructor() {
      super();
      this.listproducts = this.querySelector('.menuListProducts');
      let flkty = new Flickity(this.listproducts, {
        // Opciones de Flickity
        cellAlign: 'center',
        contain: true,
        wrapAround: true, // Hace que el carrusel sea infinito
        prevNextButtons: false,
        pageDots: false
      });
      if (this.listproducts.classList.contains("cartnoempty")) {
        this.listproducts.style.opacity = "1";
        this.listproducts.style.visibility = "visible";
      }
    }
  }
  customElements.define('cart-drawer-carousel', CartDrawerCarousel);
});



